module.exports = __webpack_public_path__ + "img/china.53f3f3ca.png";